module.exports = __webpack_public_path__ + "static/media/food.e270cae7.svg";